import axios from 'axios';
import { authService } from './authService';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:42026';

function authHeaders() {
  const token = authService.getToken();
  return token ? { 'x-access-token': token } : {};
}

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface OnboardingCompletePayload {
  palName: string;
  crownJewelData: string;
  sensitivityLevel: number;
  integrations: string[];
  conversationSummary: string;
}

export interface OnboardingConnectionPayload {
  serviceType: string;
  serviceName: string;
  category: string;
  authMethod: 'api_key' | 'connection_string';
  credentials: string;
  config: Record<string, any>;
}

export const onboardingService = {
  async chat(message: string, history: ChatMessage[]): Promise<string> {
    const res = await axios.post(
      `${API_BASE_URL}/api/onboarding/chat`,
      { message, history },
      { headers: authHeaders() }
    );
    return res.data.reply as string;
  },

  async getStatus(): Promise<boolean> {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/onboarding/status`, {
        headers: authHeaders()
      });
      return res.data.onboardingCompleted === true;
    } catch {
      return false;
    }
  },

  async complete(payload: OnboardingCompletePayload): Promise<void> {
    await axios.post(
      `${API_BASE_URL}/api/onboarding/complete`,
      payload,
      { headers: authHeaders() }
    );
  },

  async demoEncode(text: string): Promise<{ masked: string; entityTypes: string[]; twins: Array<{ original: string; twin: string; entityType: string }>; fallback?: boolean }> {
    const res = await axios.post(
      `${API_BASE_URL}/api/onboarding/demo`,
      { text },
      { headers: authHeaders() }
    );
    return res.data;
  },

  async getAgentConfig() {
    const res = await axios.get(`${API_BASE_URL}/api/onboarding/agent-config`, {
      headers: authHeaders()
    });
    return res.data;
  },

  async createConnection(payload: OnboardingConnectionPayload): Promise<{ id: string; serviceType: string } | null> {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/onboarding/connections`,
        payload,
        { headers: authHeaders() }
      );
      return res.data?.connection || null;
    } catch {
      return null;
    }
  },
};
